var _rect, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaceholderLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 80,
    height: 80,
    rx: 10,
    fill: "#e3edfa",
    stroke: "#1976d2",
    strokeWidth: 2
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 60,
    textAnchor: "middle",
    fill: "#1976d2",
    fontFamily: "Arial, sans-serif",
    fontSize: 14,
    fontWeight: "bold"
  }, "LOGO")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholderLogo);
export default __webpack_public_path__ + "static/media/placeholder-logo.2df4ab82e75a30bdbf061226c00ccdb7.svg";
export { ForwardRef as ReactComponent };